import { EVENT_TYPES, matchClock, isExtraTime } from "@/lib/events";

const PLURAL = {
  falta: ["falta", "faltas"], amarelo: ["amarelo", "amarelos"], vermelho: ["vermelho", "vermelhos"],
  ca_por_exibir: ["CA por exibir", "CA por exibir"], cv_por_exibir: ["CV por exibir", "CV por exibir"],
  pp: ["PP", "PP"], pp_por_assinalar: ["PP por assinalar", "PP por assinalar"],
  golo: ["golo", "golos"], autogolo: ["autogolo", "autogolos"], substituicao: ["substituição", "substituições"],
  vantagem: ["vantagem", "vantagens"], fj_aa1: ["fora de jogo AA1", "foras de jogo AA1"], fj_aa2: ["fora de jogo AA2", "foras de jogo AA2"],
  assistencia: ["assistência", "assistências"], outros: ["outro", "outros"],
  falta_aa1: ["falta AA1", "faltas AA1"], falta_aa2: ["falta AA2", "faltas AA2"],
};

export const BUCKETS = [
  { label: "0 a 15 min", period: 1, idx: 0 }, { label: "16 a 30 min", period: 1, idx: 1 }, { label: "31 a 45 min", period: 1, idx: 2 },
  { label: "46 a 60 min", period: 2, idx: 0 }, { label: "61 a 75 min", period: 2, idx: 1 }, { label: "76 a 90 min", period: 2, idx: 2 },
];
const ET_BUCKETS = [{ label: "91 a 105 min", period: 3, idx: 0 }, { label: "106 a 120 min", period: 4, idx: 0 }];

const bucketOf = (e, reset) => {
  if (e.period >= 3) return 0;
  const minute = Math.floor(matchClock(e.seconds, e.period, reset) / 60) - (e.period === 2 ? 45 : 0);
  return Math.min(2, Math.max(0, Math.floor(minute / 15)));
};

const joinPt = (parts) => (parts.length < 2 ? parts.join("") : `${parts.slice(0, -1).join(", ")} e ${parts[parts.length - 1]}`);

const summarize = (evs) => {
  const counts = EVENT_TYPES.map((t) => ({ t, n: evs.filter((e) => e.type === t.key).length })).filter((c) => c.n > 0);
  return { counts, text: joinPt(counts.map(({ t, n }) => `${n} ${PLURAL[t.key][n > 1 ? 1 : 0]}`)) || "—" };
};

export const SUMMARY_SIDES = ["home", "away", "none"];

const specialOf = (e) => (e.halftime ? "int" : e.phase || null);
const SPECIAL = [{ label: "Pré-jogo", special: "pre_jogo" }, { label: "Intervalos", special: "int" }, { label: "Penáltis", special: "penaltis" }, { label: "Pós-jogo", special: "pos_jogo" }];

export const periodSummary = (match) =>
  [...BUCKETS, ...(isExtraTime(match) ? ET_BUCKETS : []), ...SPECIAL.filter((s) => match.events.some((e) => specialOf(e) === s.special))].map((b) => {
    const evs = match.events.filter((e) => (b.special ? specialOf(e) === b.special
      : !specialOf(e) && (e.period || 1) === b.period && bucketOf(e, match.half2_reset) === b.idx));
    return {
      ...b,
      home: summarize(evs.filter((e) => e.team === "home")),
      away: summarize(evs.filter((e) => e.team === "away")),
      none: summarize(evs.filter((e) => !e.team)),
    };
  });

export const hasTeamless = (match) => match.events.some((e) => !e.team);
